import { makeAutoObservable } from 'mobx';
import { AuthStore } from 'stores/users/AuthStore';
import { serverUri } from 'utils/config';

export class DeleteUserStore {
  constructor(private readonly authStore: AuthStore) {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  async deleteUser() {
    try {
      const response = await this.authStore.fetchWithAuth(`${serverUri}/user`, {
        method: 'DELETE',
      });
      if (!response.ok) throw new Error('Error deleting user');
      this.authStore.forceLogout();
    } catch (err) {}
  }
}
